import React, { FC } from 'react';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { CustomSVG, ICustomSVG } from './';

interface IProps {
  active: boolean;
  provider: keyof ICustomSVG;
  className?: string;
  size?: number;
}

interface IPropsEnhanced extends IProps, WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginRight: 12,
    },
    inactive: {
      color: theme.palette.action.disabled,
    },
    twitter: {
      color: theme.custom.networks.twitter,
    },
    linkedin: {
      color: theme.custom.networks.linkedin,
    },
    facebook: {
      color: theme.custom.networks.facebook,
    },
  });

const SocialAccountIcon: FC<IPropsEnhanced> = ({ classes, className, active, provider, size }) => (
  <CustomSVG
    className={classNames(className || classes.root, {
      [classes[provider]]: active,
      [classes.inactive]: !active,
    })}
    name={provider}
    size={size}
  />
);

SocialAccountIcon.defaultProps = {
  size: 28,
};

export default withStyles(styles)(SocialAccountIcon);
